import { render, staticRenderFns } from "./TransitionDates.vue?vue&type=template&id=06c2aef8&"
import script from "./TransitionDates.vue?vue&type=script&lang=js&"
export * from "./TransitionDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports